module.exports = __webpack_public_path__ + "static/enzyme-2255fe0a62d761fb726c1adfcc160b9f.png";